<template>
  <div
    class="app"
    :class="`current-scene-${currentScene}`"
  >
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <!-- <button
            class="scene__nav scene__nav--previous button"
            v-if="currentScene > 1"
            @click="previousScene()"
          >
            <span class="scene__nav-inner">Back</span>
          </button> -->
          <button
            class="scene__nav scene__nav--next button"
            @click="nextScene()"
            v-if="!beginButton && currentScene === 2"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button>
          <!-- <button
            class="mute"
            :class="{
              'muted': muted
            }"
            @click="toggleMute()"
          >toggle mute</button> -->
          <button
            class="scene__begin button"
            @click="begin()"
            v-if="beginButton"
          >Begin</button>

          <div
            class="scene scene-1"
            :class="{
              'active': currentScene === 1,
              'active-play': currentScene === 1 && !beginButton
            }"
          >
            <p class="text">At home, we use a remote control to adjust volume (amplitude). <i>Kids Work! ETV's</i> audio engineer adjusts audio levels for television productions.</p>

            <div class="tv">
              <div class="face-host" v-if="!beginButton"></div>
              <div class="remote-1"></div>
              <div class="remote-2"></div>
            </div>

          </div>
          <div
            class="scene scene-2"
            :class="{
              'active': currentScene === 2
            }"
          >
            <p class="text">The intensity (loudness or softness) of sound is determined by the amplitude of the sound wave. Let's examine a sound wave. Touch the parts of the sound wave to read a definition.</p>
            
            <dl>
              <dt class="crest"><a href="#" @mouseover="playHover">Crest</a></dt>
                <dd class="crest"><span>Crest</span> The highest points on the wave</dd>
              <dt class="wavelength"><a href="#" @mouseover="playHover">Wavelength</a></dt>
                <dd class="wavelength"><span>Wavelength</span> The distance between two corresponding points of a wave (crest to crest; trough to trough).</dd>
              <dt class="trough"><a href="#" @mouseover="playHover">Trough</a></dt>
                <dd class="trough"><span>Trough</span> The lowest points on the wave</dd>
              <dt class="amplitude"><a href="#" @mouseover="playHover">Amplitude</a></dt>
                <dd class="amplitude"><span>Amplitude</span> The distance from the rest position to a crest or to a trough.</dd>
            </dl>

            <p class="instruction">Click the next button when you are finished.</p>
          </div>
          <div
            class="scene scene-3"
            :class="{
              'active': currentScene === 3
            }"
          >
            
            <p class="text">The host is using a microphone and the guest is wearing a clip-on microphone.
            The audio engineer monitors the levels on an audio console.</p>
            <div class="talkshow">
              <p class="mic mic-1"><span>Mic 1</span></p>
              <p class="mic mic-2"><span>Mic 2</span></p>
            </div>

          </div>
          <div
            class="scene scene-4"
            :class="{
              'active': currentScene === 4
            }"
          >
            
            <p class="text">At the top of the audio console is a VU meter.  The VU meter visually shows the amplitude. Good levels are between -3 and 0.  Levels should not be too low or too high.</p>
            <div class="talkshow">
              <p class="mic mic-1"><span>Mic 1</span></p>
              <p class="mic mic-2"><span>Mic 2</span></p>
            </div>

            <div class="meter">
              <div class="indicator"></div>
              <div class="limit limit-low">too low</div>
              <div class="limit limit-high">too high</div>
            </div>

          </div>

          <div
            class="scene scene-5"
            :class="{
              'active': currentScene === 5
            }"
          >
            
            <p class="text">Faders are used to balance the audio levels. They work like the volume button on a remote control.</p>
            <div class="talkshow">
              <p class="mic mic-1"><span>Mic 1</span></p>
              <p class="mic mic-2"><span>Mic 2</span></p>
            </div>

            <div class="sliderpanel">
              <div class="slider slider-1"></div>
              <div class="slider slider-2"></div>
            </div>

          </div>

          <div
            class="scene scene-6"
            :class="{
              'active': currentScene === 6
            }"
          >
            
            <p class="text">As the host and the guest talk, adjust the levels. Remember the levels should not be too low or high.</p>
            <div class="talkshow">
              <p class="mic mic-1"><span>Mic 1</span></p>
              <p class="mic mic-2"><span>Mic 2</span></p>
            </div>

            <div class="controls">
              <div class="meter">
                <div class="indicator"></div>
              </div>

              <div class="sliderpanel">
                <div class="slider slider-1"></div>
                <div class="slider slider-2"></div>
              </div>
            </div>

          </div>

          <div
            class="scene scene-7"
            :class="{
              'active': currentScene === 7
            }"
          >
            <p class="caption caption-1" v-if="trackTime < 8">Hi, I'm Maria your host of "Kids Work Tells All." Today, we're speaking with Rick who has just returned from an adventure at the Kids Work Zoo. Hello Rick.</p>
            <p class="caption caption-2" v-if="trackTime >= 8 && trackTime < 11">Hello Maria and hi boys and girls ...</p>
            <p class="caption caption-3" v-if="trackTime >= 11 && trackTime < 15">First of all, Rick, please share with our Kids Work audience, something you learned at the Zoo.</p>
            <p class="caption caption-4" v-if="trackTime >= 15 && trackTime < 24">Sure, Maria! My first stop at the zoo was the Monkey Zone. I really like watching the  monkeys do wild things like swing from trees and climb around on those great jungle gyms they have!</p>
            <p class="caption caption-5" v-if="trackTime >= 24 && trackTime < 33"> I noticed the monkeys spend a lot of time grooming themselves and each other. They even show affection for one another, sometimes even getting into fights and then making up!</p>
            <p class="caption caption-6" v-if="trackTime >= 33 && trackTime < 38">Wow! Rick you observed many interesting things. What else did you notice at the Zoo?</p>
            <p class="caption caption-7" v-if="trackTime >= 38 && trackTime < 46">Well, Maria, I also noticed that the young monkeys stay very close to their mothers. Monkeys are mammals, and the young monkeys need their mother for food, to stay</p>
            <p class="caption caption-8" v-if="trackTime >= 46 && trackTime < 54">warm, and for protection until they are big enough to play on their own. The zoo keeper told me that the young monkeys are called "infants" or "juveniles", just like humans!</p>
            <p class="caption caption-9" v-if="trackTime >= 54 && trackTime < 60">Rick, you're on your way to becoming an expert on the subject of primate behavior. That's about all the time we have. Thanks Rick.</p>
            <p class="text" v-if="trackTime >= 60"> I know you have more information to share; so we hope you'll join us again on "Kids Work Tells All."</p>
            
            <div class="talkshow">
              <div class="face-host"></div>
              <div class="face-guest"></div>
              <p class="mic mic-1"><span>Mic 1</span></p>
              <p class="mic mic-2"><span>Mic 2</span></p>
            </div>

            <div class="slider-box">
              <p class="error error-high" v-if="volumeLevel >= 85">too high!</p>
              <p class="error error-ok" v-if="volumeLevel < 85 && volumeLevel > 30">sound ok</p>
              <p class="error error-low" v-if="volumeLevel <= 30">too low!</p>

              <p class="label label-1">Mic 1</p>
              <p class="label label-2">Mic 2</p>

              <vue-slider
                class="audio-slider"
                direction="btt"
                v-model="volumeLevel"
                @change="
                  setVolumeByName({ name: 'scene7', volume: volumeLevel / 50 })
                "
              ></vue-slider>
              <!-- slider here -->
            </div>


             <div class="tv" v-if="trackTime >= 60 && trackTime < 64">
              <div class="face-host"></div>
            </div>

            <div class="endscreen" v-if="trackTime >= 60"></div>

            <a href="https://www.knowitall.org/interactive/audio-engineer-kids-work" class="endbutton" v-if="trackTime >= 60">End</a>

          </div>

          

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'app',
  data: function() {
    return {
      volumeLevel: 70
    };
  },
  computed: {
    ...mapState([
      'numScenes',
      'currentScene',
      'beginButton',
      'trackTime'
    ]),
    nextButtonText () {
      if (this.currentScene < this.numScenes) {
        return 'Next'
      } else {
        return 'End'
      }
    }
  },
  methods: {
    ...mapMutations([
      'HIDE_BEGIN_BUTTON',
      'RESET_TRACK_INTERVAL'
    ]),
    ...mapActions([
      'begin',
      'previousScene',
      'nextScene',
      'setVolumeByName',
      'playHover'
    ])
  },
  watch: {
    trackTime: function() {
      if (this.currentScene === 1 && this.trackTime > 12) {
        this.nextScene()
      }
      if (this.currentScene === 3 && this.trackTime > 9) {
        this.nextScene()
      }
      if (this.currentScene === 4 && this.trackTime > 14) {
        this.nextScene()
      }
      if (this.currentScene === 5 && this.trackTime > 6) {
        this.nextScene()
      }
      if (this.currentScene === 6 && this.trackTime > 7) {
        this.nextScene()
      }
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: #FFF;
}
</style>
